import { CarWheelPosition, CarWheelPositionText, TireSeason } from '@navio/nsdk';
import { INSPECTION_WHEELS, tireDimensionRegex } from 'noddi-util';
import { z } from 'zod';

export const createWheelSetSchema = z.object({
  tireSeason: z.enum(TireSeason),
  frontDimension: z.string().regex(tireDimensionRegex, 'Enter dimensions, for example 205/55R16'),
  rearDimension: z
    .string()
    .refine((value) => !value || tireDimensionRegex.test(value), 'Enter dimensions, for example 205/55R16'),
  frontLeft: z.number().min(0).max(50).nullable(),
  frontRight: z.number().min(0).max(50).nullable(),
  rearLeft: z.number().min(0).max(50).nullable(),
  rearRight: z.number().min(0).max(50).nullable()
});

export type CreateWheelSetValues = z.input<typeof createWheelSetSchema>;

/** The four wheels a set is created from, in the canonical order and wording. */
export const wheelSetPositions = INSPECTION_WHEELS.map(({ field, location, label }) => ({
  key: field,
  label,
  position: location,
  measurementPosition: CarWheelPosition[location],
  rear: location === CarWheelPositionText.REAR_LEFT || location === CarWheelPositionText.REAR_RIGHT
}));
